<template>
  <div class="app" :class="$route.path=='/isoti'?['isoti']:[]">
    <router-view/>
  </div>
</template>

<script>
export default {
}
</script>

<style>

</style>